angular.module('content.widgets.DCSWidgetController', [
  'content.widgets.DCSWidgetService'
])

/**
 * The DCSWidgetController manages scope logic and user
 * interaction.
 *
 * @class DCSWidgetController
 * @constructor
 * @module content.widgets.DCSWidgetController
 **/
.controller('DCSWidgetController', [
  '$scope',
  'DCSWidgetService',
  '$timeout',
  function ($scope, DCSWidgetService, $timeout) {
    'use strict';

    var requiredList = [];

    $scope.formattedModel = {};

    $scope.state = {
      selected: null,
      breadcrumbs: [],
      list: [],
      media: []
    };

    $scope.form = {
      schema: null,
      form: null,
      model: null
    };

    /**
     * Selects an item in the widget heriarchy
     *
     * @param {string} id - ID of the selected item
     */
    $scope.select = function select(id) {
      var breadcrumbs = [{ label: $scope.formattedModel.title, id: null }];
      var item = DCSWidgetService.get(id, $scope.formattedModel);

      if (!item) {
        $scope.state.selected = null;
        $scope.state.list = $scope.formattedModel.collection;
        $scope.state.media = $scope.formattedModel.media;
      } else if (item.collection) {
        $scope.state.selected = item;
        $scope.state.list = item.collection;
        $scope.state.media = null;
      }

      $scope.state.breadcrumbs = breadcrumbs.concat(DCSWidgetService.getBreadcrumbs(id));
    };

    /**
     * Returns the model captured from edit mode
     *
     * @return {Object} Widget instance model
     */
    $scope.getModel = function getModel() {
      return DCSWidgetService.getModel($scope.form.model);
      // return $scope.formattedModel;
    };

    /**
     * checkRequired checks to see if the model is emty or not
     *
     * @param {Object} model - instance model
     * @param {UUID} id - instance identifier
     */
    $scope.checkRequired = function checkRequired(model, id) {
      var inList = _.indexOf(requiredList, id);
      if (model === '') {
        requiredList.push(id);
      } else if (model !== '' && inList !== -1) {
        requiredList.splice(inList, 1);
      }

      if (requiredList.length) {
        $timeout(function () {
          $scope.$emit('can-save', { canSave: true });
        });
      }
    };

    /**
     * Method executes the initialization process.
     *
     * @private
     */
    function initialize() {
      // emits an event passing the current scope.  This scope is picked up by the
      // associated theme to register as the active scope.
      // This event is required to initialize a widget
      $scope.$emit('setCurrentContentScope', $scope);

      $scope.formattedModel = {
        title: $scope.model.label,
        type: $scope.model.content.type,
        media: $scope.model.content.media,
        collection: $scope.model.content.collection
      };

      $scope.form = DCSWidgetService.configureForm($scope.formattedModel);
      $scope.pristineModel = _.cloneDeep($scope.form.model);
      $scope.$watch('form.model', function (nv) {
        var nvReplaced = angular.toJson(nv);
        var pristineReplaced = angular.toJson($scope.pristineModel);
        var testEquality = _.isEqual(nvReplaced, pristineReplaced);

        $scope.$emit('can-save', { canSave: testEquality });
      }, true);

      $scope.select(null);
    }

    initialize();
  }
]);
